import { makeKey, update } from "../../../../utils/reducerOperations";
export function changePasswordStarted(state, payload) {
  return makeKey(
    "changePasswordApi",
    update(state.changePasswordApi, { isProcessing: true })
  );
}
